export const products = {
  free: {
    priceId: 'price_1RNeN0RtB0k9odPOLiyuzoGx',
    name: 'Free',
    description: 'Try AI-powered analysis on one video',
    mode: 'subscription' as const,
    price: 0,
    analyses: 1,
    features: [
      'Complete AI content analysis',
      '1 analysis per month',
      'Data-backed predictions from 11,000+ videos',
      'Community support (48h response)'
    ],
    legacyPriceIds: []
  },
  creator: {
    priceId: 'price_1Smho3RtB0k9odPO5MdQr6kL',
    name: 'Creator',
    description: 'Great for hobbyists and small creators building their audience',
    mode: 'subscription' as const,
    price: 9.99,
    analyses: 15,
    features: [
      'Complete AI content analysis',
      '15 analyses per month',
      'Data-backed predictions from 11,000+ videos',
      'Priority support (24h response)'
    ],
    legacyPriceIds: []
  },
  pro: {
    priceId: 'price_1SmhovRtB0k9odPOH30FyYsv',
    name: 'Pro',
    description: 'Ideal for growing creators with 1K-100K followers',
    mode: 'subscription' as const,
    price: 24.99,
    analyses: 50,
    features: [
      'Complete AI content analysis',
      '50 analyses per month',
      'Data-backed predictions from 11,000+ videos',
      'Priority support (12h response)'
    ],
    legacyPriceIds: ['price_1RVuMHRtB0k9odPOjG7ZM5I0', 'price_1RNeJzRtB0k9odPODs7oq09t']
  },
  agency: {
    priceId: 'price_1SmhsnRtB0k9odPOgUo0BYGE',
    name: 'Agency',
    description: 'Perfect for agencies and multi-account managers',
    mode: 'subscription' as const,
    price: 79.99,
    analyses: 200,
    features: [
      'Complete AI content analysis',
      '200 analyses per month',
      'Data-backed predictions from 11,000+ videos',
      'Priority support (4h response)',
      'Multi-account management'
    ],
    legacyPriceIds: []
  },
  starter: {
    priceId: 'price_1RVuUgRtB0k9odPOYQvIvTFE',
    name: 'Starter Plan (Legacy)',
    description: 'Legacy plan - no longer available for new subscribers',
    mode: 'subscription' as const,
    price: 19.99,
    analyses: 30,
    features: [
      'Complete AI content analysis',
      '30 analyses per month',
      'Standard support (24h response)'
    ],
    legacyPriceIds: ['price_1RNeJ9RtB0k9odPOZOlFvv7E']
  }
};